// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/WalletChangeRequests.jsx.
 * Loaded AFTER index.css (and after the page's inline \\3c style>) so
 * equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577–991px
 *   laptop  : 992–1280px
 *   desktop : >=1281px
 *
 * DO NOT EDIT src/index.css. All overrides live here.
 */

/* Mobile card list is hidden by default; shown only on mobile via media query below */
.wallet-change-requests-page .request-card-list {
  display: none;
}

/* ===========================================================================
 * TABLET (<=991px): compact stats grid, minor layout tweaks
 * ======================================================================== */
@media (max-width: 991px) {
  .wallet-change-requests-page .stats-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  /* Ensure table container allows horizontal scroll on tablet */
  .wallet-change-requests-page .table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full single-column, app-like layout
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Page wrapper ---- */
  .wallet-change-requests-page {
    padding: 0;
  }

  /* ---- Page header ---- */
  .wallet-change-requests-page .page-header {
    margin-bottom: 16px;
  }

  .wallet-change-requests-page .page-header h1 {
    font-size: 20px;
  }

  /* ---- Stats grid: 2 columns on mobile (5 cards -> 3+2) ---- */
  .wallet-change-requests-page .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 16px;
  }

  /* Compact stat cards */
  .wallet-change-requests-page .stat-card {
    padding: 12px;
    gap: 10px;
  }

  .wallet-change-requests-page .stat-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
  }

  .wallet-change-requests-page .stat-value {
    font-size: 20px;
  }

  .wallet-change-requests-page .stat-label {
    font-size: 12px;
  }

  /* Make stat-cards proper touch targets */
  .wallet-change-requests-page .stat-card.clickable {
    min-height: 44px;
  }

  /* ---- Table -> card list on mobile ---- */
  .wallet-change-requests-page .table-container {
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;
  }

  /* Hide the desktop table */
  .wallet-change-requests-page .data-table {
    display: none;
  }

  /* Show card list (hidden by default, shown only on mobile) */
  .wallet-change-requests-page .request-card-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Individual request card */
  .wallet-change-requests-page .request-row-card {
    background: var(--bg-primary);
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 14px 16px;
  }

  .wallet-change-requests-page .request-row-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 10px;
  }

  .wallet-change-requests-page .request-row-card-merchant {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .wallet-change-requests-page .request-row-card-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 10px;
  }

  .wallet-change-requests-page .card-field {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .wallet-change-requests-page .card-field-label {
    font-size: 11px;
    font-weight: 600;
    color: var(--text-muted);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .wallet-change-requests-page .card-field-value {
    font-size: 13px;
    color: var(--text-primary);
    word-break: break-all;
  }

  .wallet-change-requests-page .card-field-value.mono {
    font-family: 'SF Mono', 'Monaco', 'Menlo', monospace;
  }

  .wallet-change-requests-page .request-row-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding-top: 10px;
    border-top: 1px solid var(--border-color);
  }

  .wallet-change-requests-page .card-date {
    font-size: 12px;
    color: var(--text-secondary);
  }

  .wallet-change-requests-page .card-actions {
    display: flex;
    gap: 8px;
  }

  /* Ensure approve/reject buttons meet touch target on mobile */
  .wallet-change-requests-page .btn-approve,
  .wallet-change-requests-page .btn-reject {
    width: 44px;
    height: 44px;
    border-radius: 8px;
  }

  /* ---- Pagination: compact on mobile ---- */
  .wallet-change-requests-page .pagination {
    flex-wrap: wrap;
    gap: 6px;
    padding: 12px 0;
  }

  .wallet-change-requests-page .pagination button {
    min-width: 44px;
    min-height: 44px;
    padding: 10px;
    justify-content: center;
  }

  .wallet-change-requests-page .page-info {
    font-size: 13px;
    padding: 0 8px;
    text-align: center;
    width: 100%;
    order: -1;
  }

  /* ---- Modals -> bottom sheets ---- */
  .wallet-change-requests-page .modal-overlay {
    align-items: flex-end;
  }

  .wallet-change-requests-page .modal {
    max-width: 100%;
    width: 100%;
    border-radius: 16px 16px 0 0;
    max-height: 92vh;
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  /* Modal header: drag handle + extra top padding */
  .wallet-change-requests-page .modal-header {
    position: relative;
    padding: 20px 20px 16px;
  }

  .wallet-change-requests-page .modal-header::before {
    content: '';
    display: block;
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 36px;
    height: 4px;
    background: var(--border-color);
    border-radius: 2px;
  }

  .wallet-change-requests-page .modal-body {
    padding: 16px 20px;
  }

  /* Modal footer: stack buttons full-width */
  .wallet-change-requests-page .modal-footer {
    flex-direction: column-reverse;
    gap: 8px;
    padding: 12px 20px;
  }

  .wallet-change-requests-page .btn-primary,
  .wallet-change-requests-page .btn-secondary {
    width: 100%;
    min-height: 48px;
    text-align: center;
    justify-content: center;
  }

  /* ---- Address change: always column on mobile ---- */
  .wallet-change-requests-page .address-change {
    flex-direction: column;
    align-items: stretch;
  }

  /* ---- Form textarea: prevent iOS zoom ---- */
  .wallet-change-requests-page .form-group textarea {
    font-size: 1rem;
    min-height: 80px;
  }

  /* ---- Summary rows: stack label above value ---- */
  .wallet-change-requests-page .summary-row {
    flex-direction: column;
    gap: 4px;
  }

  .wallet-change-requests-page .summary-row .label {
    min-width: unset;
  }

  /* ---- Modal close button: touch target ---- */
  .wallet-change-requests-page .modal-close {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/WalletChangeRequests.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF,sFAAsF;AACtF;EACE,aAAa;AACf;;AAEA;;6EAE6E;AAC7E;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA,8DAA8D;EAC9D;IACE,gBAAgB;IAChB,iCAAiC;EACnC;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,2BAA2B;EAC3B;IACE,UAAU;EACZ;;EAEA,0BAA0B;EAC1B;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA,+DAA+D;EAC/D;IACE,qCAAqC;IACrC,SAAS;IACT,mBAAmB;EACrB;;EAEA,uBAAuB;EACvB;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,yCAAyC;EACzC;IACE,gBAAgB;EAClB;;EAEA,2CAA2C;EAC3C;IACE,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,2BAA2B;EAC3B;IACE,aAAa;EACf;;EAEA,6DAA6D;EAC7D;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA,4BAA4B;EAC5B;IACE,6BAA6B;IAC7B,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,wBAAwB;IACxB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,0BAA0B;IAC1B,qBAAqB;EACvB;;EAEA;IACE,oDAAoD;EACtD;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA,8DAA8D;EAC9D;;IAEE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA,4CAA4C;EAC5C;IACE,eAAe;IACf,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,SAAS;EACX;;EAEA,sCAAsC;EACtC;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,8CAA8C;EAChD;;EAEA,kDAAkD;EAClD;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,WAAW;IACX,+BAA+B;IAC/B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,2CAA2C;EAC3C;IACE,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA,sDAAsD;EACtD;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA,8CAA8C;EAC9C;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,oDAAoD;EACpD;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;;EAEA,+CAA+C;EAC/C;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/WalletChangeRequests.jsx.\n * Loaded AFTER index.css (and after the page's inline <style>) so\n * equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577–991px\n *   laptop  : 992–1280px\n *   desktop : >=1281px\n *\n * DO NOT EDIT src/index.css. All overrides live here.\n */\n\n/* Mobile card list is hidden by default; shown only on mobile via media query below */\n.wallet-change-requests-page .request-card-list {\n  display: none;\n}\n\n/* ===========================================================================\n * TABLET (<=991px): compact stats grid, minor layout tweaks\n * ======================================================================== */\n@media (max-width: 991px) {\n  .wallet-change-requests-page .stats-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n  }\n\n  /* Ensure table container allows horizontal scroll on tablet */\n  .wallet-change-requests-page .table-container {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full single-column, app-like layout\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Page wrapper ---- */\n  .wallet-change-requests-page {\n    padding: 0;\n  }\n\n  /* ---- Page header ---- */\n  .wallet-change-requests-page .page-header {\n    margin-bottom: 16px;\n  }\n\n  .wallet-change-requests-page .page-header h1 {\n    font-size: 20px;\n  }\n\n  /* ---- Stats grid: 2 columns on mobile (5 cards -> 3+2) ---- */\n  .wallet-change-requests-page .stats-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    margin-bottom: 16px;\n  }\n\n  /* Compact stat cards */\n  .wallet-change-requests-page .stat-card {\n    padding: 12px;\n    gap: 10px;\n  }\n\n  .wallet-change-requests-page .stat-icon {\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n  }\n\n  .wallet-change-requests-page .stat-value {\n    font-size: 20px;\n  }\n\n  .wallet-change-requests-page .stat-label {\n    font-size: 12px;\n  }\n\n  /* Make stat-cards proper touch targets */\n  .wallet-change-requests-page .stat-card.clickable {\n    min-height: 44px;\n  }\n\n  /* ---- Table -> card list on mobile ---- */\n  .wallet-change-requests-page .table-container {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    overflow: visible;\n  }\n\n  /* Hide the desktop table */\n  .wallet-change-requests-page .data-table {\n    display: none;\n  }\n\n  /* Show card list (hidden by default, shown only on mobile) */\n  .wallet-change-requests-page .request-card-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  /* Individual request card */\n  .wallet-change-requests-page .request-row-card {\n    background: var(--bg-primary);\n    border: 1px solid var(--border-color);\n    border-radius: 10px;\n    padding: 14px 16px;\n  }\n\n  .wallet-change-requests-page .request-row-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 8px;\n    margin-bottom: 10px;\n  }\n\n  .wallet-change-requests-page .request-row-card-merchant {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--text-primary);\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .wallet-change-requests-page .request-row-card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-bottom: 10px;\n  }\n\n  .wallet-change-requests-page .card-field {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  .wallet-change-requests-page .card-field-label {\n    font-size: 11px;\n    font-weight: 600;\n    color: var(--text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n  }\n\n  .wallet-change-requests-page .card-field-value {\n    font-size: 13px;\n    color: var(--text-primary);\n    word-break: break-all;\n  }\n\n  .wallet-change-requests-page .card-field-value.mono {\n    font-family: 'SF Mono', 'Monaco', 'Menlo', monospace;\n  }\n\n  .wallet-change-requests-page .request-row-card-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    padding-top: 10px;\n    border-top: 1px solid var(--border-color);\n  }\n\n  .wallet-change-requests-page .card-date {\n    font-size: 12px;\n    color: var(--text-secondary);\n  }\n\n  .wallet-change-requests-page .card-actions {\n    display: flex;\n    gap: 8px;\n  }\n\n  /* Ensure approve/reject buttons meet touch target on mobile */\n  .wallet-change-requests-page .btn-approve,\n  .wallet-change-requests-page .btn-reject {\n    width: 44px;\n    height: 44px;\n    border-radius: 8px;\n  }\n\n  /* ---- Pagination: compact on mobile ---- */\n  .wallet-change-requests-page .pagination {\n    flex-wrap: wrap;\n    gap: 6px;\n    padding: 12px 0;\n  }\n\n  .wallet-change-requests-page .pagination button {\n    min-width: 44px;\n    min-height: 44px;\n    padding: 10px;\n    justify-content: center;\n  }\n\n  .wallet-change-requests-page .page-info {\n    font-size: 13px;\n    padding: 0 8px;\n    text-align: center;\n    width: 100%;\n    order: -1;\n  }\n\n  /* ---- Modals -> bottom sheets ---- */\n  .wallet-change-requests-page .modal-overlay {\n    align-items: flex-end;\n  }\n\n  .wallet-change-requests-page .modal {\n    max-width: 100%;\n    width: 100%;\n    border-radius: 16px 16px 0 0;\n    max-height: 92vh;\n    padding-bottom: env(safe-area-inset-bottom, 0);\n  }\n\n  /* Modal header: drag handle + extra top padding */\n  .wallet-change-requests-page .modal-header {\n    position: relative;\n    padding: 20px 20px 16px;\n  }\n\n  .wallet-change-requests-page .modal-header::before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 8px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 36px;\n    height: 4px;\n    background: var(--border-color);\n    border-radius: 2px;\n  }\n\n  .wallet-change-requests-page .modal-body {\n    padding: 16px 20px;\n  }\n\n  /* Modal footer: stack buttons full-width */\n  .wallet-change-requests-page .modal-footer {\n    flex-direction: column-reverse;\n    gap: 8px;\n    padding: 12px 20px;\n  }\n\n  .wallet-change-requests-page .btn-primary,\n  .wallet-change-requests-page .btn-secondary {\n    width: 100%;\n    min-height: 48px;\n    text-align: center;\n    justify-content: center;\n  }\n\n  /* ---- Address change: always column on mobile ---- */\n  .wallet-change-requests-page .address-change {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  /* ---- Form textarea: prevent iOS zoom ---- */\n  .wallet-change-requests-page .form-group textarea {\n    font-size: 1rem;\n    min-height: 80px;\n  }\n\n  /* ---- Summary rows: stack label above value ---- */\n  .wallet-change-requests-page .summary-row {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .wallet-change-requests-page .summary-row .label {\n    min-width: unset;\n  }\n\n  /* ---- Modal close button: touch target ---- */\n  .wallet-change-requests-page .modal-close {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
